type LashBrowValidationLike = {
  isValidated?: boolean | null;
  allowsAnalysis?: boolean | null;
};

/**
 * True when a resolved lash/brow validation verdict means the user must retake the photo before
 * analysis can run.
 *
 * The allow/block decision is computed server-side — the backend `LashBrowImageValidationIssueClassifier`
 * that the consumer-flow saga gates on — and surfaced as `allowsAnalysis`. The client reads that single
 * authoritative flag rather than re-deriving the hard-block / non-blocking issue rules. Returns false
 * while the verdict is unresolved (`isValidated` falsy or `allowsAnalysis` null) so callers keep waiting
 * rather than prematurely rejecting.
 */
export function isRejectedLashBrowValidation(
  validation: LashBrowValidationLike | null | undefined,
): boolean {
  return validation?.isValidated === true && validation.allowsAnalysis === false;
}
